<template>
  <div class="check-manage">
    <subfield>
      <template slot="list">
        <trees
          :title="$t('crc1')"
          type="GROUP"
          @getAssets="getAssets"
          :list="groupList"
        ></trees>
      </template>
      <template slot="content">check-manage</template>
    </subfield>
  </div>
</template>

<script>
import subfield from '@/components/basics/Subfield'
import trees from '@/components/basics/Trees'
export default {
  name: 'CheckManage',
  data() {
    return {
      groupList: []
    }
  },
  created() {
    this.$http.post("/admin/access/groupList", {}, data => {
      this.groupList = data;
    });    
  },
  methods: {
    getAssets(ids) {
      console.log(ids);
    }
  },
  components: {
    subfield,
    trees
  }
}
</script>

<style lang="scss" scoped>
.check-manage {
  width: 100%;
  height: 100%;
}
</style>